import {
  setSearchTerm,
} from '@redux/ducks/users';

/**
 * @ngdoc controller
 * @name adjust.accountSettings.controller:UsersController
 *
 * @description
 * Users management tab
 *
 */
function UsersController(Account, $location, $state, $scope, $ngRedux) {
  'ngInject';
  var vm = this;

  vm.goTo = goTo;
  vm.goToUsers = goToUsers;
  vm.setQuery = setQuery;

  $scope.$emit('account-settings:active', 'users');

  const _mapDispatchToVm = {
    setSearchTerm,
  };

  vm.$onInit = () => {
    const unsubscribe = $ngRedux.connect(null, _mapDispatchToVm)(vm);
    $scope.$on('$destroy', () => {
      vm.setSearchTerm('');
      unsubscribe();
    });

    const searchTerm = $location.search().user;

    if (searchTerm) {
      vm.setSearchTerm(searchTerm);
    }
  };

  /**
   * @param {string} to
   * @param {object=} params
   */
  function goTo(to, params) {
    $state.go(to, params);
  }

  /**
   * @param {string} key
   * @param {string} value
   */
  function setQuery(key, value) {
    $location.search(key, value || null).replace();
  }

  /**
   * @ngdoc method
   * @name goToApps
   * @methodOf adjust.accountSettings.controller:UsersController
   *
   * @description
   * Go to apps route when right panel is closed
   */
  function goToUsers() {
    goTo('accountSettings.users');
  }
}
export { UsersController };
